<template>
  <ul class="booklist clearfix">
    <li :class="{ big: big }" v-for="(item, index) in booklist" :key="index">
      <template v-if="item.book">
        <dl>
          <dt>
            <router-Link
              :to="'/bookdetail/' + item.book.id"
              :target="isNewWindow ? '_blank' : ''"
            >
              <img v-lazy="imgURL + item.book.iconUrl" :alt="item.book.name" />
            </router-Link>
          </dt>
          <dd>
            <router-Link
              :to="'/bookdetail/' + item.book.id"
              :target="isNewWindow ? '_blank' : ''"
            >
              <h4 :title="item.book.name">{{ item.book.name }}</h4>
            </router-Link>
            <a
              href="javaScript:"
              target="_blank"
              v-if="item.book.author != undefined"
            >
              <em class="author">{{ item.book.author.name }}</em>
            </a>
            <p>
              {{ item.book.introduce }}
            </p>

            <a class="tag" href="javaScript:" target="_blank">
              {{ item.book.sort }}</a
            >
          </dd>
        </dl>
      </template>
      <template v-else>
        <dl>
          <dt>
            <router-Link
              :to="'/bookdetail/' + item.id"
              :target="isNewWindow ? '_blank' : ''"
            >
              <img v-lazy="imgURL + item.iconUrl" :alt="item.name" />
            </router-Link>
          </dt>
          <dd>
            <router-Link
              :to="'/bookdetail/' + item.id"
              :target="isNewWindow ? '_blank' : ''"
            >
              <h4 :title="item.name">{{ item.name }}</h4>
            </router-Link>
            <a
              href="javaScript:"
              target="_blank"
              v-if="item.author != undefined"
            >
              <em class="author">{{ item.author.name }}</em>
            </a>
            <p>
              {{ item.introduce }}
            </p>

            <a class="tag" href="javaScript:" target="_blank">
              {{ item.sort }}</a
            >
          </dd>
        </dl>
      </template>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    big: Boolean,
    booklist: Array,
    isNewWindow: Boolean
  }
};
</script>

<style lang="stylus" scoped>
.booklist
    padding-top 24px
    li
        float left
        margin 0 27px 30px 0
        width 140px
        &.big
            width 176px
            margin 0 28px 0px 0
            dl
                dt
                    height 258px
                    img
                        width 176px
                        height 236px
        &:nth-child(6n)
            margin-right 0px
        &:hover
            dl
                dt
                    transform translate3d(0, -3%, 0)
        dl
            dt
                transition all 0.17s ease-in-out
                -webkit-transform translateZ(0)
                -webkit-transition all 0.17s ease-in-out
                transform translateZ(0)
                height 200px
                img
                    width 140px
                    height 182px
                    box-shadow 0 5px 5px rgba(0, 0, 0, 0.35)
            dd
                h4
                    height 28px
                    line-height 28px
                    text-overflow ellipsis
                    white-space nowrap
                    overflow hidden
                    font-size 16px
                    color #333
                    margin-bottom 6px
                    &:hover
                        color #48a2df
                .author
                    display block
                    white-space nowrap
                    font-size 13px
                    margin-bottom 12px
                    text-overflow ellipsis
                    overflow hidden
                    color #999
                    &:hover
                        color #707070
                p
                    height 54px
                    text-align justify
                    display -webkit-box
                    -webkit-line-clamp 3
                    -webkit-box-orient vertical
                    line-height 18px
                    font-size 12px
                    margin-bottom 12px
                    text-overflow ellipsis
                    overflow hidden
                    word-break break-all
                    word-wrap break-word
                    color #999
                .tag
                    display inline-block
                    height 18px
                    border 1px solid #48a2df
                    border-radius 2px
                    color #48a2df
                    padding 0 7px
                    margin 0 6px 0 0
                    font-size 14px
</style>
